<h2 mat-dialog-title>Gestion des utilisateurs</h2>
<mat-dialog-content>
    <app-user-selection (selected)="selectUser($event)" [mode]="'admin'"></app-user-selection>
    <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
        <div fxFlex="33%">
            <h3 mat-dialog-title>Etablissements</h3>
            <app-user-domain-list [domains]="userDomains"></app-user-domain-list>
        </div>
        <div fxFlex="33%">
            <h3 mat-dialog-title>Départements</h3>
            <app-user-department-list [departments]="userDepartments"></app-user-department-list>
        </div>
        <div fxFlex="33%">
            <h3 mat-dialog-title>Groupes</h3>
            <app-user-group-list [groups]="userGroups"></app-user-group-list>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Fermer</button>
</mat-dialog-actions>